import React from 'react';

const STORAGE_KEY = 'chunk-reload-attempted';

// Wraps React.lazy: on a failed dynamic import (stale chunk after a deploy),
// force one full reload to fetch a fresh index.html + new chunk hashes.
const lazyWithRetry = (componentImport) =>
  React.lazy(async () => {
    const alreadyReloaded = JSON.parse(
      window.sessionStorage.getItem(STORAGE_KEY) || 'false',
    );
    try {
      const component = await componentImport();
      window.sessionStorage.setItem(STORAGE_KEY, 'false');
      return component;
    } catch (error) {
      if (!alreadyReloaded) {
        window.sessionStorage.setItem(STORAGE_KEY, 'true');
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  });

export default lazyWithRetry;
